import { useState, useEffect } from 'react';

export const useVoiceTypes = () => {
    const [voiceTypeMap, setVoiceTypeMap] = useState({});

    useEffect( () => {
        async function getVoiceTypes() {
            const result = await fetch("/go/api/v1/voice-types/search?size=1000");
            const json = await result.json();

            if (!json.hits || !json.hits.hits.length) {
                return;
            }
            const newMap = {};

            json.hits.hits.forEach((inst) => {
                newMap[inst._source.id] = inst._source;
            });

            setVoiceTypeMap(newMap);
        }

        getVoiceTypes();
    }, []);

    return voiceTypeMap;
};
